import flow from "@src/assets/images/flow.png"
import supply from "@src/assets/images/supply.png"
import icon01 from "@src/assets/sidebar/01.png"
import icon02 from "@src/assets/sidebar/02.png"
import icon03 from "@src/assets/sidebar/03.png"
import icon04 from "@src/assets/sidebar/04.png"
import icon05 from "@src/assets/sidebar/05.png"
import icon07 from "@src/assets/sidebar/07.png"
import icon08 from "@src/assets/sidebar/08.png"
import icon09 from "@src/assets/sidebar/09.png"
import icon10 from "@src/assets/sidebar/10.png"
import icon11 from "@src/assets/sidebar/11.png"
import icon12 from "@src/assets/sidebar/12.png"
import icon13 from "@src/assets/sidebar/13.png"
import icon14 from "@src/assets/sidebar/14.png"
import icon15 from "@src/assets/sidebar/15.png"
import icon16 from "@src/assets/sidebar/16.png"
import icon17 from "@src/assets/sidebar/17.png"
import icon18 from "@src/assets/sidebar/18.png"
import icon19 from "@src/assets/sidebar/19.png"
import icon20 from "@src/assets/sidebar/20.png"
import finance from "@src/assets/sidebar/finance.png"
import system from "@src/assets/sidebar/system.png"

interface NavObj {
  path: string //菜单路由
  name: string //菜单名称
  icon: string //菜单图标
  code: string //菜单编码
  id: string //菜单id
  parentid: string | null //菜单父id
  children?: NavObj[] //子菜单
  meta?: {
    microRouteName: string
  }
}
export const navConfig: Menu.MenuOptions[] | any = [
  {
    name: "数据统计",
    path: "/data/chart",
    value: "data",
    code: "op_data",
    key: "data",
    parentid: "4",
    children: [
      {
        name: "数据看板",
        path: "/data/chart",
        icon: icon01,
        code: "op_data_chart",
        key: "data_chart",
        parentid: "4-1",
      },
      {
        name: "数据统计",
        path: "/data/statistics",
        icon: icon03,
        code: "op_data_statistics",
        key: "data_statistics",
        parentid: "4-4",
      },
      {
        name: "数据大屏",
        path: "/data/large",
        icon: icon02,
        code: "op_data_large",
        key: "data_large",
        parentid: "4-2",
      },
      {
        name: "补贴发放统计",
        path: "/data/subsidy-grant",
        icon: finance,
        code: "op_data_subsidy_grant",
        key: "data_subsidy_grant",
        parentid: "4-3",
      },
    ],
  },
  {
    name: "交易中心",
    path: "/entity/transaction/procureOrder",
    value: "entity",
    code: "op_entity",
    key: "entity",
    parentid: "1",
    children: [
      {
        name: "采购订单",
        code: "op_entity_order_purchase",
        key: "entity_order_purchase",
        icon: icon05,
        parentid: "1-1",
        path: "/entity/transaction/procureOrder",
      },
      {
        name: "补差订单",
        code: "op_entity_order_difference",
        key: "entity_order_purchase",
        icon: icon05,
        parentid: "1-3",
        path: "/entity/transaction/differenceOrder",
      },
      {
        name: "开票名称",
        path: "/entity/transaction/invoice",
        code: "op_platform_children_invoice",
        icon: icon11,
        key: "platform_children_invoice",
        parentid: "1-6",
      },
      {
        name: "交易方案",
        icon: icon04,
        path: "/entity/transaction/tradingScheme",
        code: "op_entity_tradingScheme",
        key: "entity_transaction_tradingScheme",
        parentid: "1-2",
      },
      {
        name: "优惠券发放",
        icon: icon03,
        path: "/entity/transaction/coupon",
        code: "op_entity_transaction_coupon",
        key: "entity_transaction_coupon",
        parentid: "1-5",
      },
      {
        name: "积分商城管理",
        icon: icon03,
        path: "/entity/transaction/pointsMall",
        code: "op_entity_transaction_pointsMall",
        key: "entity_transaction_pointsMall",
        parentid: "1-11",
      },
      {
        name: "资金流水",
        icon: finance,
        path: "/entity/transaction/records",
        code: "op_entity_transaction_records",
        key: "op_entity_transaction_records",
        parentid: "1-10",
      },
      {
        name: "预付款台账",
        icon: finance,
        path: "/entity/transaction/depositBalances",
        code: "op_entity_transaction_depositBalances",
        key: "op_entity_transaction_depositBalances",
        parentid: "1-10",
      },
      {
        name: "客商查询",
        icon: finance,
        path: "/entity/transaction/merchant",
        code: "op_entity_transaction_merchant",
        key: "op_entity_transaction_merchant",
        parentid: "1-10",
      },
      {
        name: "收购报废产品台账",
        icon: finance,
        path: "/entity/transaction/purchaseAndScrap",
        code: "op_entity_transaction_purchaseAndScrap",
        key: "op_entity_transaction_purchaseAndScrap",
        parentid: "1-10",
      },
      {
        name: "订单应付台账",
        icon: finance,
        path: "/entity/transaction/orderPayableLedger",
        code: "op_entity_transaction_orderPayableLedger",
        key: "op_entity_transaction_orderPayableLedger",
        parentid: "1-10",
      },
    ],
  },
  {
    name: "平台设置",
    path: "/platformSetup/user",
    value: "platformSetup",
    code: "op_platform",
    key: "platform",
    parentid: "1",
    children: [
      {
        name: "产品数据底座",
        path: "/platformSetup/productTemplate",
        code: "op_platform_product_template",
        key: "op_platform_product_template",
        // key: "agencyBusiness-setup",
        parentid: "20-1",
        icon: icon12,
        children: [
          {
            name: "平台类目",
            path: "/platformSetup/productTemplate",
            code: "op_platform_product_template_category",
            key: "op_platform_product_template_category",
            parentid: "20-2",
          },
          {
            name: "类目参数",
            path: "/platformSetup/productTemplate/categoryParams",
            code: "op_platform_product_template_category_params",
            key: "op_platform_product_template_category_params",
            parentid: "20-3",
            icon: icon05,
          },
          {
            name: "电池资产",
            path: "/platformSetup/productTemplate/batteryAssets",
            code: "op_platform_battery_assets",
            key: "op_platform_battery_assets",
            parentid: "20-3",
          },
          {
            name: "产品模型",
            path: "/platformSetup/productTemplate/productModal",
            code: "op_platform_product_template_product_modal",
            // key: "platform_children-user",
            key: "op_platform_product_template_product_modal",
            parentid: "20-3",
          },
          {
            name: "开户银行管理",
            path: "/platformSetup/bank",
            code: "op_platform_bank",
            key: "op_platform_bank",
            parentid: "20-4",
          },
          {
            name: "省市区管理",
            path: "/platformSetup/city",
            code: "op_platform_city",
            key: "op_platform_city",
            parentid: "20-5",
          },
        ],
      },
      {
        name: "组织管理",
        path: "/platformSetup/tissue",
        code: "op_platform_children_tissue",
        icon: icon09,
        key: "platform_children_tissue",
        parentid: "3-1",
      },
      {
        name: "用户管理",
        path: "/platformSetup/user",
        code: "op_platform_children_user",
        icon: icon07,
        key: "platform_children-user",
        parentid: "1-1",
      },
      {
        name: "税区管理",
        path: "/platformSetup/district",
        code: "op_platform_children_district",
        icon: icon10,
        key: "platform_children_district",
        parentid: "4-1",
      },
      {
        name: "合同模板",
        icon: icon05,
        path: "/platformSetup/contractTemplate",
        code: "op_platform_transaction_contractList",
        key: "entity_transaction_contractList",
        parentid: "1-3",
      },
      {
        name: "二维码",
        code: "op_platform_publicAccount_twoCode",
        key: "platform_publicAccount_twoCode",
        parentid: "9-1-2",
        icon: icon07,
        path: "/platformSetup/publicAccount/twoCode",
      },
      {
        name: "应用管理",
        path: "/platformSetup/apply",
        code: "op_platform_children_apply",
        icon: icon08,
        key: "platform_children_apply",
        parentid: "2-1",
      },
      {
        name: "同步新再生网订单",
        path: "/platformSetup/utilOrder",
        code: "op_platform_children_utilOrder",
        icon: supply,
        key: "platform_children_utilOrder",
        parentid: "6-1",
      },
      {
        name: "入驻审核",
        path: "/platformSetup/check",
        code: "op_platform_check",
        icon: icon07,
        key: "platform_check",
        parentid: "8-1",
      },
      {
        name: "支付开通",
        path: "/platformSetup/paymentActivation",
        code: "op_platform_payment_activation",
        icon: finance,
        key: "platform_payment_activation",
        parentid: "8-1",
      },
      {
        name: "价格指数配置",
        path: "/platformSetup/priceIndexConfig",
        code: "op_platform_priceIndexConfig",
        icon: icon07,
        key: "platform_priceIndexConfig",
        parentid: "8-1",
      },
      {
        name: "光伏组件指导价",
        path: "/platformSetup/pvGuidePrice",
        code: "op_platform_pvGuidePrice",
        icon: system,
        key: "op_platform_pvGuidePrice",
        parentid: "8-1",
      },
      {
        name: "内容管理",
        path: "/platformSetup/content",
        code: "op_platform_content",
        icon: icon07,
        key: "platform_content",
        parentid: "8-1-2",
      },
      {
        name: "入驻配置",
        path: "/platformSetup/inviteConfig",
        code: "op_platform_inviteConfig",
        icon: icon07,
        key: "platform_inviteConfig",
        parentid: "8-2",
      },
      {
        name: "支付设置",
        path: "/platformSetup/paySet",
        code: "op_platform_children_paySet",
        icon: supply,
        key: "platform_children_paySet",
        parentid: "6-1",
      },
      {
        name: "人员管理",
        path: "/platformSetup/personalManagement/userManage",
        code: "op_system_personal_management",
        key: "platform_user",
        // key: "agencyBusiness-setup",
        parentid: "7-1",
        icon: icon12,
        children: [
          {
            name: "用户管理",
            path: "/platformSetup/personalManagement/userManage",
            code: "op_platform_userManage",
            key: "op_system_userManage",
            parentid: "7-2",
          },
          {
            name: "角色管理",
            path: "/platformSetup/personalManagement/role",
            code: "op_system_role_list",
            // key: "platform_children-user",
            key: "agencyBusiness_children-OutSetup",
            parentid: "7-3",
          },
        ],
      },
      {
        name: "审批管理",
        path: "/platformSetup/approvalManagement",
        code: "op_platform_approval_management",
        key: "op_platform_approval_management",
        // key: "agencyBusiness-setup",
        parentid: "20-1",
        icon: flow,
      },
      {
        name: "工单管理",
        path: "/platformSetup/resourceWorkOrder",
        code: "op_platform_resource_work_order",
        key: "platform_resource_work_order",
        // key: "agencyBusiness-setup",
        parentid: "21-1",
        icon: icon05,
      },
    ],
  },
  {
    name: "代办业务",
    path: "/agencyBusiness/setup",
    value: "agencyBusiness",
    code: "op_businessAgent",
    // key: "platform",
    key: "agencyBusiness",
    parentid: "1",
    children: [
      {
        name: "工商税务开办",
        path: "/agencyBusiness/setup",
        code: "op_agencyBusiness",
        key: "platform_user",
        // key: "agencyBusiness-setup",
        parentid: "1-1",
        icon: icon12,
        children: [
          {
            name: "个体户开办申请",
            path: "/agencyBusiness/setup",
            code: "op_agencyBusiness_setup",
            // key: "platform_children-user",
            key: "agencyBusiness_children-setup",
            parentid: "1-1-2",
          },
          {
            name: "个体户注销申请",
            path: "/agencyBusiness/OutSetup",
            code: "op_agencyBusiness_outSetup",
            // key: "platform_children-user",
            key: "agencyBusiness_children-OutSetup",
            parentid: "1-1-3",
          },
          {
            name: "工商年报申报",
            path: "/agencyBusiness/annual",
            code: "op_agencyBusiness_annual",
            key: "agencyBusiness_annual",
            parentid: "1-1-6",
          },
          {
            name: "扣税流水记录",
            path: "/agencyBusiness/deductions",
            code: "op_agencyBusiness_deductions",
            key: "agencyBusiness_children-deductions",
            parentid: "1-1-4",
          },
          {
            name: "附加税缴纳记录",
            path: "/agencyBusiness/surtax",
            code: "op_agencyBusiness_surtax",
            key: "agencyBusiness_surtax",
            parentid: "1-1-5",
          },
          {
            name: "个体户完税凭证",
            path: "/agencyBusiness/taxPaid",
            code: "op_agencyBusiness_taxPaid",
            key: "agencyBusiness_taxPaid",
            parentid: "1-1-7",
          },
        ],
      },
    ],
  },
  {
    name: "税票系统",
    path: "/ticket/openTask",
    code: "op_openTask",
    // key: "openTask",
    value: "ticketOpenTask",
    key: "ticket",
    parentid: "1",
    children: [
      {
        name: "开票",
        path: "/ticket/openTask",
        code: "op_ticket",
        key: "op_ticket",
        parentid: "1-1",
        icon: icon13,
        children: [
          {
            name: "开通任务",
            path: "/ticket/openTask",
            code: "op_ticket_openTask",
            key: "op—ticket-openTask",
            parentid: "1-1-1",
          },
          {
            name: "开票方列表",
            path: "/ticket/invoicingParty",
            code: "op_ticket_invoicingParty",
            key: "op—ticket-invoicingParty",
            parentid: "1-1-2",
          },
          {
            name: "开票任务",
            path: "/ticket/InvoicingTask",
            code: "op_ticket_InvoicingTask",
            key: "op—ticket-InvoicingTask",
            parentid: "1-2-3",
          },
          {
            name: "发票台账",
            path: "/ticket/ledger",
            code: "op_ticket_ledger",
            key: "op—ticket-ledger",
            parentid: "1-3-4",
          },
          {
            name: "开票地址矫正",
            path: "/ticket/regionCorrection",
            code: "op_ticket_regionCorrection",
            key: "op—ticket-regionCorrection",
            parentid: "1-3-5",
          },
        ],
      },
    ],
  },
  {
    name: "存证平台",
    path: "/evidence/platform/template",
    code: "op_evidence",
    value: "evidence",
    key: "evidence",
    parentid: "1",
    children: [
      {
        name: "平台配置",
        path: "/evidence/platform/template",
        code: "op_evidence_set",
        key: "op_evidence_set",
        parentid: "15",
        icon: icon14,
        children: [
          {
            name: "存证场景模板",
            code: "op_evidence_set_scene",
            key: "op_evidence_set_scene",
            path: "/evidence/platform/template",
            icon: supply,
            parentid: "15-1",
          },
          {
            name: "存证字段维护",
            code: "op_evidence_field",
            key: "op_evidence_field",
            path: "/evidence/platform/field",
            icon: supply,
            parentid: "15-2",
          },
        ],
      },
    ],
  },
  {
    name: "物联管理",
    path: "/internet",
    code: "op_internet",
    value: "internet",
    key: "internet",
    parentid: "1",
    children: [
      {
        name: "监控管理",
        path: "/internet",
        code: "op_internet_things",
        key: "op_internet_things",
        parentid: "15",
        icon: icon15,
      },
    ],
  },
  {
    name: "供应链运营",
    path: "/supplyChainOperation",
    code: "op_supplyChainOperation",
    value: "supplyChainOperation",
    key: "supplyChainOperation",
    parentid: "1",
    children: [
      {
        name: "企业组织管理",
        path: "/supplyChainOperation/organization",
        code: "op_supplyChainOperation_organization",
        key: "op_supplyChainOperation_organization",
        parentid: "15",
        icon: icon09,
      },
      {
        name: "企业分组管理",
        path: "/supplyChainOperation/group",
        code: "op_supplyChainOperation_group",
        key: "op_supplyChainOperation_group",
        parentid: "15",
        icon: icon07,
      },
      {
        name: "地图资源管理",
        path: "/supplyChainOperation/mapResource",
        code: "op_supplyChainOperation_mapResource",
        key: "op_supplyChainOperation_mapResource",
        parentid: "15",
        icon: icon18,
      },
      {
        name: "变更审批",
        path: "/supplyChainOperation/changeApproval",
        code: "op_supplyChainOperation_changeApproval",
        key: "op_supplyChainOperation_changeApproval",
        parentid: "15",
        icon: icon19,
      },
      {
        name: "数据填报",
        path: "/supplyChainOperation/dataReport/template",
        code: "op_supplyChainOperation_dataReport",
        key: "op_supplyChainOperation_dataReport",
        parentid: "15",
        icon: icon01,
        children: [
          {
            name: "模板管理",
            path: "/supplyChainOperation/dataReport/template",
            code: "op_supplyChainOperation_dataReport_template",
            key: "op_supplyChainOperation_dataReport_template",
            parentid: "15-1",
          },
          {
            name: "填报记录",
            path: "/supplyChainOperation/dataReport/summary",
            code: "op_supplyChainOperation_dataReport_summary",
            key: "op_supplyChainOperation_dataReport_summary",
            parentid: "15-2",
          },
        ],
      },
    ],
  },
  {
    name: "供应链金融",
    path: "/finance",
    code: "op_finance",
    value: "finance",
    key: "finance",
    parentid: "1",
    children: [
      {
        name: "融资订单",
        path: "/finance/order",
        code: "op_finance_financing",
        key: "op_finance_financing",
        parentid: "15",
        icon: icon16,
      },
      {
        name: "核心企业准入",
        path: "/finance/enterprise",
        code: "op_finance_enterprise",
        key: "op_finance_enterprise",
        parentid: "15",
        icon: icon17,
      },
      {
        name: "供应商准入",
        path: "/finance/consent",
        code: "op_finance_consent",
        key: "op_finance_consent",
        parentid: "15",
        icon: icon18,
      },
      {
        name: "融资产品",
        path: "/finance/product",
        code: "op_finance_product",
        key: "op_finance_product",
        parentid: "15",
        icon: icon19,
      },
    ],
  },
  {
    name: "物流管理",
    path: "/logistics",
    code: "op_logistics",
    value: "logistics",
    key: "logistics",
    parentid: "1",
    children: [
      {
        name: "云仓管理",
        path: "/logistics/warehouse",
        code: "op_logistics_warehouse",
        key: "op_logistics_warehouse",
        parentid: "49",
        icon: icon20,
      },
      {
        name: "物流轨迹",
        path: "/logistics/trajectory",
        code: "op_logistics_trajectory",
        key: "op_logistics_trajectory",
        parentid: "50",
        icon: icon20,
      },
    ],
  },
  {
    name: "运营中心",
    path: "/elevator/lift/large",
    code: "op_elevator",
    value: "elevator",
    key: "elevator",
    parentid: "100",
    children: [
      {
        name: "数据统计",
        path: "/elevator/lift/large",
        code: "op_elevator_statistics",
        key: "op_elevator_statistics",
        parentid: "100",
        icon: icon01,
        children: [
          {
            name: "数据大屏",
            path: "/elevator/lift/large",
            code: "op_elevator_data_large",
            key: "op_elevator_data_large",
            parentid: "9-1",
          },
          {
            name: "投票统计",
            path: "/elevator/vote",
            code: "op_elevator_vote",
            key: "op_elevator_vote",
            parentid: "9-2",
          },
          {
            name: "电梯更新进度统计",
            path: "/elevator/data_statistics",
            code: "op_elevator_voting_statistics",
            key: "op_elevator_voting_statistics",
            parentid: "9-3",
          },
        ],
      },
      {
        name: "电梯更新",
        path: "/elevator/management",
        code: "op_elevator_update",
        key: "op_elevator_update",
        parentid: "10",
        icon: icon20,
        children: [
          {
            name: "旧梯管理",
            code: "op_elevator_management",
            key: "op_elevator_management",
            path: "/elevator/management",
            parentid: "10-1",
          },
          {
            name: "项目库",
            code: "op_elevator_project",
            key: "op_elevator_project",
            path: "/elevator/project",
            parentid: "10-3",
          },
          {
            name: "拆梯分配",
            code: "op_elevator_dismantling_allocation",
            key: "op_elevator_dismantling_allocation",
            path: "/elevator/dismantlingAllocation",
            parentid: "10-4",
          },
        ],
      },
      {
        name: "小区管理",
        code: "op_elevator_community",
        key: "op_elevator_community",
        path: "/elevator/community",
        icon: icon17,
        parentid: "10-15",
      },
      {
        name: "设备管理",
        code: "op_equipment",
        key: "op_equipment",
        parentid: "31",
        icon: icon19,
        path: "/elevator/equipment/list",
        children: [
          {
            name: "设备列表",
            path: "/elevator/equipment/list",
            code: "op_equipment_list",
            key: "op_equipment_list",
            parentid: "17-1",
          },
          {
            name: "设备详情",
            path: "/elevator/equipment/detail",
            // code: "op_equipment_detail",
            // key: "op_equipment_detail",
            parentid: "17-1",
          },
        ],
      },
      {
        name: "投票管理",
        code: "op_vote",
        key: "op_vote",
        parentid: "17",
        icon: icon19,
        path: "/elevator/vote/list",
        children: [
          {
            name: "投票列表",
            path: "/elevator/vote/list",
            code: "op_vote_list",
            key: "op_vote_list",
            parentid: "17-1",
          },
          {
            name: "投票管理",
            path: "/elevator/vote/management",
            code: "op_vote_Management",
            key: "op_vote_list", //随后添加
            parentid: "17-1",
          },
          // {
          //   name: "投票统计",
          //   // path: "/elevator/vote/InitiateVote",
          //   code: "op_vote_initiate",
          //   key: "op_vote_initiate",
          //   parentid: "17-2",
          // },
        ],
      },
      {
        name: "电梯全生命周期",
        path: "/elevator/ladder",
        code: "op_elevator_cycle",
        key: "op_elevator_cycle",
        parentid: "11",
        icon: icon20,
        children: [
          {
            name: "一梯一档",
            code: "op_elevator_ladder",
            key: "op_elevator_ladder",
            path: "/elevator/ladder",
            parentid: "11-1",
          },
        ],
      },
      {
        name: "施工方案",
        path: "/elevator/constructionPlan/planManagement",
        code: "op_platform_construction_plan",
        key: "op_platform_construction_plan",
        parentid: "22-1",
        icon: icon07,
        children: [
          {
            name: "方案审核",
            path: "/elevator/constructionPlan/planManagement",
            code: "op_platform_construction_plan_management",
            key: "op_platform_construction_plan_management",
            parentid: "22-2",
          },
          {
            name: "评分方案",
            path: "/elevator/constructionPlan/markingScheme",
            code: "op_platform_construction_plan_marking_scheme",
            key: "op_platform_construction_plan_marking_scheme",
            parentid: "22-2",
          },
        ],
      },
      {
        name: "电梯维保",
        path: "/elevator/maintenance",
        code: "op_elevator_maintenance",
        key: "op_elevator_maintenance",
        parentid: "11",
        icon: icon20,
        children: [
          {
            name: "维保计划",
            code: "op_elevator_maintenance_plan",
            key: "op_elevator_maintenance_plan",
            path: "/elevator/maintenance/plan",
            parentid: "11-2",
          },
          {
            name: "维保工单",
            code: "op_elevator_maintenance_work_order",
            key: "op_elevator_maintenance_work_order",
            path: "/elevator/maintenance/work-order",
            parentid: "11-2",
          },
        ],
      },
      {
        name: "服务单位",
        path: "/elevator/service",
        code: "op_elevator_service",
        key: "op_elevator_service",
        parentid: "12",
        icon: icon20,
        children: [
          {
            name: "电梯厂商",
            code: "op_elevator_assembly",
            key: "op_elevator_assembly",
            path: "/elevator/service",
            parentid: "12-2",
          },

          {
            name: "监理单位",
            code: "op_elevator_auditing_units",
            key: "op_elevator_auditing_units",
            path: "/elevator/auditingUnits",
            parentid: "12-2",
          },
          {
            name: "产权单位",
            code: "op_elevator_property_units",
            key: "op_elevator_property_units",
            path: "/elevator/propertyUnits",
            parentid: "12-7",
          },
          {
            name: "维保单位",
            code: "op_elevator_maintenance_units",
            key: "op_elevator_maintenance_units",
            path: "/elevator/maintenanceUnits",
            parentid: "12-8",
          },

          {
            name: "物业公司",
            code: "op_elevator_property",
            key: "op_elevator_property",
            path: "/elevator/property",
            parentid: "12-9",
          },
          // {
          //   name: "街道",
          //   code: "op_elevator_street",
          //   key: "op_elevator_street",
          //   path: "/elevator/street",
          //   parentid: "10-4",
          // },
          // {
          //   name: "金融保险机构",
          //   code: "op_elevator_finance",
          //   key: "op_elevator_finance",
          //   path: "/elevator/finance",
          //   parentid: "10-5",
          // },
          {
            name: "政府部门",
            code: "op_elevator_department",
            key: "op_elevator_department",
            path: "/elevator/department",
            parentid: "10-6",
          },
          {
            name: "拆梯施工单位",
            code: "op_elevator_dismantling_units",
            key: "op_elevator_dismantling_units",
            path: "/elevator/dismantlingUnits",
            parentid: "12-2",
          },
        ],
      },
      {
        name: "财务管理",
        code: "op_financial_management",
        key: "op_financial_management",
        parentid: "1-1",
        icon: icon19,
        path: "/elevator/finance/billDetail",
        children: [
          {
            name: "收支明细",
            path: "/elevator/finance/billDetail",
            code: "op_financial_management_billDetail",
            key: "op_financial_management_billDetail",
            parentid: "1-1-2",
          },
        ],
      },
      {
        name: "合同管理",
        path: "/elevator/contract",
        code: "op_contract",
        key: "op_contract",
        parentid: "1-2",
        icon: icon11,
      },
      {
        name: "工单管理",
        path: "/elevator/complaint_hand",
        code: "op_complaint_hand",
        key: "op_complaint_hand",
        parentid: "1-3",
        icon: icon05,
      },
      {
        name: "安全管理",
        path: "/elevator/safety/riskControl",
        code: "op_elevator_safety",
        key: "op_elevator_safety",
        parentid: "1-4",
        icon: icon19,
        children: [
          {
            name: "风险管控",
            path: "/elevator/safety/riskControl",
            code: "op_elevator_safety_risk_control",
            key: "op_elevator_safety_risk_control",
            parentid: "1-4-1",
          },
        ],
      },
    ],
  },
]

export const deepLoopFloat = (menuList: Menu.MenuOptions[], codeList: string[]) => {
  const arr: Menu.MenuOptions[] = []
  menuList.forEach((item: Menu.MenuOptions) => {
    const obj: Menu.MenuOptions = {
      name: "",
      path: "",
      code: "",
      value: "",
      key: "",
    }
    if (codeList && codeList?.indexOf(item?.code) > -1) {
      obj.path = item?.path
      obj.value = item?.value
      obj.name = item?.name
      obj.key = item?.key
      obj.icon = item?.icon
      obj.code = item?.code
      obj.id = item?.id
      obj.parentid = item.parentid

      if (item?.children?.length) {
        obj.children = deepLoopFloat(item.children, codeList)
      }
      arr.push(obj)
    }
  })
  return arr
}
